import { render } from "./GroupItem.vue?vue&type=template&id=5446f9d4"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"

import "./GroupItem.vue?vue&type=style&index=0&id=5446f9d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__